import BaseComponent from "@/components/base/BaseComponent";
//import DxFileUploader from "devextreme-vue/file-uploader";
import http from "@/service/util/http.js";

export default {
  //mixins: [BaseComponent],
  name: "GridConfigComponent",
  data() {
    return {cfgName: ""};
  },
  created() {
    // this.columns = this.parent.columns;
  },
  methods: {
    onSearch() {
      let grid = this.$attrs.sender.$refs.DataGrid;
      let gridInstance = this.$attrs.sender.$refs.DataGrid.instance;
      let parent = this.$attrs.sender.parent;
      let columns = this.UserLib.fnObjCopy(parent.columns);

      let currentColumns =
        parent.$refs.ListComponent.$refs.DataGrid.instance._views
          .columnHeadersView._columnsController._columns;

      this.UserLib.fnRowArrayApply(columns, currentColumns);

      let pageSize = gridInstance.pageSize();
      let obj = {columns, pageSize};
      let id = parent.$route.name + "_" + grid.$el.id;
      let gridConfig = {};

      parent.$data._http.get(`/gridConfigs/new`).then((res) => {
        gridConfig = res.data;
        //gridConfig.pageId = id;
        gridConfig.gridName = this.cfgName;
        gridConfig.pageName = id;

        gridConfig.gridConfig = JSON.stringify(obj);

        parent.$data._http
          .post(`/gridConfigs/request`, gridConfig)
          .then((res1) => {
            //-- console.log(res1);
          });
      });
      //that.parent.columns = data.value.columns;

      ////-- console.log(this.$attrs.sender.returnFunc("aaa"));
      // var params = new URLSearchParams();
      // params.append(this.optString, this.optKeyword);

      // var that = this;
      // this.parent.searchSalesList(params).then((res) => {
      //   let newObj = that.UserLib.fnObjCopy(res); //Object 복사
      //   that.parent.dataSource = newObj;
      // });

      // this.optKeyword = "";
      // this.selectedIndex = 1;
    },
  },
};
